import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import BaseCard from './cards/Card';

const SPACING = 1.875;

export const Card = styled(
  React.forwardRef(({ component: Component = BaseCard, grow, size, className, ...rest }, ref) => (
    <Component ref={ref} className={`card ${className || ''}`} {...rest} />
  ))
)(({ theme, grow, size }) => ({
  borderRadius: theme.borderRadius.base,
  boxShadow: theme.boxShadow.base,
  flex: `${grow || size} 1 calc((100% / 12 * ${size}) - 2 * ${theme.spacing(SPACING)})`,
  minWidth: '300px'
}));

Card.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  size: PropTypes.string.isRequired,
  className: PropTypes.string
};

export const CardsContainer = styled('div')(({ theme, $jc }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'stretch',
  justifyContent: $jc || 'flex-start',
  margin: theme.spacing(-SPACING),
  '.card': {
    margin: theme.spacing(SPACING)
  }
}));
